import React from "react";
import { Check, ChevronDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

// Compact multi-select dropdown for streaming services.
export default function StreamerDropdown({ label, icon, streamers, isActive, onToggle, onClear, clearLabel, testId, chipPrefix, slugify }) {
  const selected = streamers.filter((s) => isActive(s.label));
  const summary = selected.length === 0 ? "None" : selected.length <= 2 ? selected.map((s) => s.label).join(", ") : `${selected.length} selected`;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={`${testId}-trigger`}
          className="inline-flex items-center gap-2 border-2 border-[#111] bg-white px-3 py-2 font-mono text-[10px] tracking-[0.2em] uppercase font-bold text-[#111] hover:bg-[#111] hover:text-white transition-colors focus-ring"
        >
          {icon}
          <span>{label}</span>
          <span className="tracking-normal normal-case font-semibold opacity-70 max-w-[180px] truncate" data-testid={`${testId}-summary`}>· {summary}</span>
          <ChevronDown size={12} strokeWidth={2.6} />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-64 p-0 border-2 border-[#111] rounded-none bg-white" data-testid={`${testId}-menu`}>
        <div className="max-h-72 overflow-y-auto py-1">
          {streamers.map((s) => {
            const active = isActive(s.label);
            return (
              <button
                key={s.label}
                type="button"
                onClick={() => onToggle(s.label)}
                aria-pressed={active}
                data-testid={`${chipPrefix}-${slugify(s.label)}`}
                className="w-full flex items-center gap-2.5 px-3 py-2 text-left font-mono text-[11px] tracking-[0.12em] uppercase font-bold text-[#111] hover:bg-[#f4f3ec] transition-colors"
              >
                <span className="w-4 h-4 border-2 flex items-center justify-center shrink-0" style={{ borderColor: s.color, background: active ? s.color : "transparent" }}>
                  {active && <Check size={10} strokeWidth={3.5} color="#fff" />}
                </span>
                {s.label}
              </button>
            );
          })}
        </div>
        {selected.length > 0 && (
          <button
            type="button"
            onClick={onClear}
            data-testid={`${testId}-clear`}
            className="w-full border-t-2 border-[#111] px-3 py-2 font-mono text-[10px] tracking-[0.25em] uppercase font-bold text-[#555] hover:bg-[#111] hover:text-white transition-colors"
          >
            {clearLabel}
          </button>
        )}
      </PopoverContent>
    </Popover>
  );
}
